import script from "./HomeCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCompanies.vue?vue&type=script&setup=true&lang=js"

import "./HomeCompanies.vue?vue&type=style&index=0&id=4a09a053&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a09a053"]])

export default __exports__